import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Route, Redirect } from 'react-router-dom';

// eslint-disable-next-line react/prefer-stateless-function
class PrivateRoute extends React.Component {
  render() {
    const { component: Component, ...rest } = this.props;

    let from = this.props.location;
    if (this.props.location.state && this.props.location.state.from) {
      from = this.props.location.state.from;
    }

    return (
      <Route
        {...rest}
        render={() =>
          this.props.isLoggedIn ? (
            <Component {...this.props} />
          ) : (
            <Redirect to={{ pathname: '/login', state: { from } }} />
          )
        }
      />
    );
  }
}

const IS_LOGGED_IN = gql`
  query IsLoggedIn {
    isLoggedIn
  }
`;

export default compose(
  graphql(IS_LOGGED_IN, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { isLoggedIn } }) => ({
      isLoggedIn,
    }),
  })
)(PrivateRoute);



// WEBPACK FOOTER //
// ./app/components/PrivateRoute/index.js